/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import fetch from 'services/fetch.service';
import userStore from 'services/user-store';
import {auth} from 'services/auth.service';

import {ISpecificNetworkReport} from 'interfaces/qosProps';

export const getNetworkReport = async(data: {networkReport: ISpecificNetworkReport}, url: string): Promise<string> => {
  const headers = new Headers();

  headers.set('Authorization', `Basic ${await userStore.get(auth.token)}`);
  headers.set('Accept', 'text/csv');

  const response = await fetch.put({
    url,
    headers,
    data,
    timeout: 60000
  });

  return response.data;
};